import { render } from "./index.vue?vue&type=template&id=ad6ed8c2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=ad6ed8c2&scoped=true&lang=css"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad6ed8c2"]])

export default __exports__